import { AxiosRestApplicationClient as OnboardingAxiosRestApplicationClient } from '@g2-shared/api-client/generated/onboarding-app';
import {
  getServerErrorMessage,
  LoggingServiceAdapter,
  NotificationAdapter,
} from '@g2-shared/common';
import { generateBaseAxiosClient } from '@g2-shared/common/libs/baseAxiosClient';

/* -------------- */
/*    QUESTIONNAIRE    */
/* -------------- */
export const FIND_QUESTIONNAIRES = 'FIND_QUESTIONNAIRES';
export const FIND_QUESTIONNAIRE_BY_ID = 'FIND_QUESTIONNAIRE_BY_ID';
export const FIND_FULL_QUESTIONNAIRE_BY_ID = 'FIND_FULL_QUESTIONNAIRE_BY_ID';
export const FIND_QUESTIONNAIRE_FIELD_BY_ID = 'FIND_QUESTIONNAIRE_FIELD_BY_ID';
export const FIND_QUESTIONNAIRES_BY_IDS = 'FIND_QUESTIONNAIRES_BY_IDS';

export const partyApiDefaultConfig = {
  retry: undefined,
  // cacheTime: Infinity,
};

export const useQuestionnaireApiDefaultConfig = (callerName: string) => {
  const { logError } = LoggingServiceAdapter();
  const { translateAndNotifyError } = NotificationAdapter();

  return {
    ...partyApiDefaultConfig,
    onError: (error: unknown) => {
      translateAndNotifyError(getServerErrorMessage(error));
      logError(error, 'Error while calling questionnaire api', callerName);
    },
  };
};

/* -------------- */
/*      AXIOS     */
/* -------------- */
const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const onboardingAxiosClient = new OnboardingAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);
